import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, Typography, Dialog, DialogTitle, DialogContent, IconButton, Tooltip } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FollowTheSignsIcon from '@mui/icons-material/FollowTheSigns';
import CloseIcon from '@mui/icons-material/Close';
import { align_center, align_row, yellowBtnStyle, vmPageTitleSx } from '../../Styles/VMStyles';
import { APPOINTMENTS, FOLLOWUPS, ROUTE_ROOMS_ALLOCATE, STATUS_CONFIRMED } from '../../Util/VMConstants';
import MUITypography from '../../Components/MUITypography';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import AddApptFollowUps from './Options/AddApptFollowUps';
import { useNavigate } from 'react-router-dom';

function VMEDOptions({ customer ,events,isConfirmedStatusArrive, hasInvoice = false, readOnly = false}) {
  const [activeOutlet, setActiveOutlet] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();


  const isConfirmed = customer.appointment_status?.toLowerCase() === STATUS_CONFIRMED.toLowerCase();
  const accChargeTypes = events.map((item)=>item.accomodation_charge_type);
  const handleOpenOutlet = (outlet) => {
    if (outlet === 'rooms' && hasInvoice) return;
    setActiveOutlet(outlet);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setActiveOutlet(null);
  };
  useEffect(()=>{
    if(isConfirmedStatusArrive === true && !hasInvoice){
      handleOpenOutlet("rooms");
    }
  },[isConfirmedStatusArrive, hasInvoice]);
  
  const renderDialogContent = () => {
    switch (activeOutlet) {
      case 'rooms':  navigate("/"+ROUTE_ROOMS_ALLOCATE,{ state: { customer: customer,events:events ,displayHeading:false  } } ); 
        return;
    
      case APPOINTMENTS:
        return <AddApptFollowUps customer={customer}  type={APPOINTMENTS} readOnly={readOnly}/>;
      case FOLLOWUPS:
        return <AddApptFollowUps customer={customer}  type={FOLLOWUPS} readOnly={readOnly}/>;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ mt: 2,mb:1 }}>
        
<Box sx={{ width: "100%", p: 0 ,pl:1,pr:3}}>
  <Stack
    direction="row"          // 🔑 ALWAYS ROW
    spacing={0}              // 🔑 NO GAPS
    alignItems="stretch"
    sx={{ width: "100%" }}
  >
    {!readOnly && (accChargeTypes.includes("") || accChargeTypes.includes("room")) && isConfirmed && (
      <Tooltip
        title={hasInvoice ? "Rooms cannot be allocated after an invoice is created" : ""}
      >
        <span style={{ flex: 1, display: "flex", marginRight: 16 }}>
          <Button
            variant="contained"
            disabled={hasInvoice}
            sx={{
              ...yellowBtnStyle,
              flex: 1,             // 🔑 EQUAL WIDTH
              borderRadius: 0,     // 🔑 TOUCHING CORNERS
              "&.Mui-disabled": {
                background: yellowBtnStyle.background,
                color: "#fff",
                opacity: 0.55,
              },
            }}
            onClick={() => handleOpenOutlet("rooms")}
          >
            <Box sx={{...align_row}}>
              <BedroomParentIcon sx={{ fontSize: 28 }} />
              <Typography variant="pageTitle" sx={{ pl: 1, ...align_center, ...vmPageTitleSx }}>
                Allocate Rooms
              </Typography>
            </Box>
          </Button>
        </span>
      </Tooltip>
    )}

    <Button
      variant="contained"
      sx={{
        ...yellowBtnStyle,
        flex: 1,
        borderRadius: 0,
        mr:1
      }}
      onClick={() => handleOpenOutlet(APPOINTMENTS)}
    >
      <Box sx={{...align_row}}>
        <CalendarMonthIcon sx={{ fontSize: 28, mr: 1 }} />
        <Typography variant="pageTitle" sx={{ ...align_center, ...vmPageTitleSx }}>
          Client Appointments
        </Typography>
      </Box>
    </Button>

    <Button
      variant="contained"
      sx={{
        ...yellowBtnStyle,
        flex: 1,
        borderRadius: 0,
      }}
      onClick={() => handleOpenOutlet(FOLLOWUPS)}
    >
      <Box sx={align_row}>
        <FollowTheSignsIcon sx={{ fontSize: 28, mr: 1 }} />
        <Typography variant="pageTitle" sx={{ ...align_center, ...vmPageTitleSx }}>
          Client FollowUps
        </Typography>
      </Box>
    </Button>
  </Stack>
</Box>


      {/* Dialog to show outlet */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={align_row}>
         <MUITypography sx={{width:'100%', ...align_center }}>
            {activeOutlet === 'vendors' && 'Event Vendors'}
            {activeOutlet === 'photos' && 'Add Event Photos'}
            {activeOutlet === 'invoice' && 'Create Invoice'}
            {activeOutlet === 'rooms' && 'Allocate Rooms'}
            {activeOutlet === APPOINTMENTS && APPOINTMENTS}
            {activeOutlet === FOLLOWUPS && FOLLOWUPS}
        </MUITypography>
          <Box>
            <IconButton onClick={handleCloseDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {renderDialogContent()}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default VMEDOptions;
